import {
  createApiRef,
  createFrontendModule,
  DiscoveryApi,
  FetchApi,
} from '@backstage/frontend-plugin-api';
import { ApiBlueprint } from '@backstage/frontend-plugin-api';
import { discoveryApiRef, fetchApiRef } from '@backstage/frontend-plugin-api';

export interface GhDataProviderApi {
  listFilesInRepoFolder(ref: string, path: string): Promise<{ name: string, downloadUrl: string }[]>;
}

export const ghDataProviderApiRef = createApiRef<GhDataProviderApi>().with({
  id: 'gh.provider',
});

class GhDataProvider implements GhDataProviderApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;
  constructor(discoveryApi: DiscoveryApi, fetchApi: FetchApi) {
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi;
  }
  private async fetch<T = any>(path: string, req?: RequestInit): Promise<T> {
    const baseUrl = await this.discoveryApi.getBaseUrl('backend-gh-provider');
    const response = await this.fetchApi.fetch(`${baseUrl}${path}`, req);
    if (!response.ok) {
      throw new Error(
        `Failed to fetch ${path}: ${response.status} ${response.statusText}`,
      );
    }
    return await response.json();
  }

  async listFilesInRepoFolder(
    ref: string,
    path: string,
  ): Promise<{ name: string; downloadUrl: string }[]> {
    const pathParam = new URLSearchParams({ path }).toString();
    return await this.fetch(`/repo/${ref}/list-files?${pathParam}`, {
      method: 'GET',
    });
  }
}

const ghDataProviderExtension = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: ghDataProviderApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => {
        return new GhDataProvider(discoveryApi, fetchApi);
      },
    }),
});

export const ghDataProviderApiModule = createFrontendModule({
  pluginId: 'app',
  extensions: [ghDataProviderExtension],
});
